<template>
    <div>
        <!--        签署中-->
        <avue-crud :data="data" :option="option" :search.sync="search" :page.sync="page" @current-change="changePage"
                   @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="voidBtn(scope.row)" v-loading.fullscreen.lock="fullscreenLoading"
                           v-if="scope.row.is_faqiren==1">作废
                </el-dropdown-item>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="faqi_ren" slot-scope="scope" >
                <el-tooltip :content="scope.row.faqi_ren" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.faqi_ren }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        作废-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <span>请确认是否要作废该合同</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { allContracts, allContractsSearch, signContract, voidContract } from '../../../api/allContracts';

    export default {
        name: 'signingPage',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10 //每页多少
                    // pagerCount:5
                },
                data: [],
                id: '',
                dialogVisible: false,
                doc_title: '',
                all_signers: '',
                fullscreenLoading: false,
                pages: 1,
                search: {
                    doc_title: '',
                    all_signers: ''
                },
                option: {
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    column: [
                        {
                            label: '合同名称',
                            prop: 'doc_title',
                            search: true
                        }, {
                            label: '平台编号',
                            prop: 'system_sn'
                        },
                        // {
                        //     label: '合同编号',
                        //     prop: 'contract_sn'
                        // },
                        {
                            label: '发起人',
                            prop: 'faqi_ren'
                        }, {
                            label: '发起时间',
                            prop: 'faqi_time'
                        }, {
                            label: '参与人',
                            prop: 'all_signers',
                            width:'500',
                            search: true
                        }, {
                            label: '合同状态',
                            prop: 'ct_status_txt'
                        },
                    ]
                }
            };
        },
        methods: {
            //分页
            changePage(num) {
                if (this.doc_title == '' && this.all_signers == '') {
                    allContracts(1, 10, num).then(res => {
                        sessionStorage.setItem('signingPage', num);
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                    });
                } else {
                    //搜索后分页
                    allContractsSearch(1, 10, num, this.doc_title, this.all_signers).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('signingPageSearch', num);
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                        }
                    });
                }
            },
            //搜索
            searchChange(from, done) {
                allContractsSearch(1, 10, 1, from.doc_title, from.all_signers).then(res => {
                    this.doc_title = from.doc_title;
                    this.all_signers = from.all_signers;
                    if (res.code == 200) {
                        sessionStorage.setItem('signingPageSearch', 1);
                        sessionStorage.setItem('signingPageParams', JSON.stringify(from));
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
                done();
            },
            //重置搜索
            resetChange() {
                this.doc_title = '';
                this.all_signers = '';
                allContracts(1, 10, this.pages).then(res => {
                    if (res.code == 200) {
                        sessionStorage.removeItem('signingPage');
                        sessionStorage.removeItem('signingPageSearch');
                        sessionStorage.removeItem('signingPageParams');
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                        this.$message.success('重置成功');
                    }

                });
            },
            //作废
            voidBtn(row) {
                this.dialogVisible = true;
                this.id = row.id;
            },
            //确认作废
            confirmBtn() {
                voidContract(this.id).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        location.reload();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        created() {
            if (sessionStorage.getItem('signingPageSearch')) {
                let signingPageParams = JSON.parse(sessionStorage.getItem('signingPageParams'));
                this.search = signingPageParams;
                this.doc_title = signingPageParams.doc_title;
                this.all_signers = signingPageParams.all_signers;
                allContractsSearch(1, 10, sessionStorage.getItem('signingPageSearch'), this.doc_title, this.all_signers).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = sessionStorage.getItem('signingPageSearch');

                    }
                });
            } else {
                if (sessionStorage.getItem('signingPage') === null) {
                    allContracts(1, 10, this.pages).then(res => {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    });
                } else {
                    allContracts(1, 10, sessionStorage.getItem('signingPage')).then(res => {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = sessionStorage.getItem('signingPage');
                    });
                }
            }

        }
    };
</script>

<style scoped>
    /deep/ .el-col {
        width: 25%;
    }

    /deep/ .avue-form__menu {
        padding: 0px;
    }

    /deep/ .el-tabs__active-bar {
        background-color: #3d62f6;
    }

    .View {
        background-color: #3e62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
</style>
